import { useEffect, useContext } from 'react';
import { GlobalContext } from "context/GlobalContext";


function KeyboardNavigateLesson(selectedValue, setSelectedValue, maxValue, fireFunc) {
  
  const {ShowFeedback, setShowFeedback} = useContext(GlobalContext);
  const switchArrowKeys = (document.body.getAttribute(`lang`)== "he") 

  useEffect(() => {
    
    const handleKeyDown = (event) => {
      // Don't prevent default if user is typing in an input, textarea, or contenteditable element
      const target = event.target;
      const isInputElement = target.tagName === 'INPUT' || 
                            target.tagName === 'TEXTAREA' || 
                            target.isContentEditable ||
                            target.closest('input') ||
                            target.closest('textarea') ||
                            target.closest('[contenteditable="true"]');
      
      if (isInputElement) {
        // Allow normal input behavior
        return;
      }
      
      event.preventDefault();
      switch (event.key) {
        case 'ArrowLeft':
          switchArrowKeys 
                  ? setSelectedValue((selectedValue < maxValue) ? (selectedValue + 1) : selectedValue)
                  : setSelectedValue((selectedValue > 0) ? (selectedValue - 1) : selectedValue)
          break;
          case 'ArrowRight':
            switchArrowKeys 
                  ? setSelectedValue((selectedValue > 0) ? (selectedValue - 1) : selectedValue)
                  : setSelectedValue((selectedValue < maxValue) ? (selectedValue + 1) : selectedValue)
          break;
        case 'ArrowUp':
          console.log("ArrowUp")
            setSelectedValue((selectedValue > 1) ? (selectedValue - 2) : (selectedValue > 0 ? selectedValue - 1 : 0));
          break;
        case 'ArrowDown':
          console.log("ArrowDown")
            setSelectedValue((selectedValue < maxValue - 1) ? (selectedValue + 2) : maxValue); 
          break;
        case ' ':
        case 'Enter':
          fireFunc();
          break;
        default:
          break;
      }
    };

    !ShowFeedback && window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [maxValue, fireFunc, setSelectedValue]);

  return selectedValue;
}


export default KeyboardNavigateLesson;
